<!--
 * @Description  :
 * @Author       : 王帅
 * @Date         : 2024-07-18 10:10:40
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-14 14:36:03
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\es-sign-order\components\detail.vue
-->
<!--
    描述：会员详情
    时间：2022-06-22
    Created by zwh
-->
<template>
  <div class="member-detail-page">
    <div class="main-content">
      <div class="top-tab">
        <el-tabs v-model="tabIndex" @tab-click="tabChange(tabIndex)">
          <el-tab-pane name="0" :key="0" label="签署流程信息">
           <tabSfi v-if="tabIndex==0"></tabSfi>
          </el-tab-pane>
          <el-tab-pane name="1" :key="1" label="本次签署信息">
            <tabCsi v-if="tabIndex==1"></tabCsi>
          </el-tab-pane>
          <el-tab-pane name="2" :key="2" label="待签署文件">
            <tabTsf v-if="tabIndex==2"></tabTsf>
          </el-tab-pane>
          <el-tab-pane name="3" :key="3" label="认证配置信息">
            <tabIci v-if="tabIndex==3"></tabIci>
          </el-tab-pane>
          <el-tab-pane name="4" :key="4" label="通知配置信息">
            <tabNci v-if="tabIndex==4"></tabNci>
          </el-tab-pane>
          <el-tab-pane name="5" :key="5" label="签署配置信息">
            <tabSci v-if="tabIndex==5"></tabSci>
          </el-tab-pane>
          <el-tab-pane name="6" :key="6" label="签署方信息">
            <tabSti v-if="tabIndex==6"></tabSti>
          </el-tab-pane>
          <el-tab-pane name="7" :key="7" label="签署区域列表数据">
            <tabSali v-if="tabIndex==7"></tabSali>
          </el-tab-pane>
          <el-tab-pane name="8" :key="8" label="签署抄送信息">
            <tabScpi v-if="tabIndex==8"></tabScpi>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

  </div>
</template>

<script>
import tabSfi from './detail_tab_sfi'
import tabCsi from './detail_tab_csi'
import tabTsf from './detail_tab_tsf'
import tabIci from './detail_tab_ici'
import tabNci from './detail_tab_nci'
import tabSci from './detail_tab_sci'
import tabSti from './detail_tab_sti'
import tabSali from './detail_tab_sali'
import tabScpi from './detail_tab_scpi'
export default {
  name: "detail",
  components:{
    tabSfi,tabCsi,tabTsf,tabIci,tabNci,tabSci,tabSti,tabSali,tabScpi
  },
  data(){
    return {
      tabIndex : 0,
      objectForm : {

      }
    }
  },
  methods :{
    tabChange(index){
      if(this.tabIndex == index) return
      this.tabIndex = index
    },
  }
}
</script>

<style lang="less" scoped>
.member-detail-page {
  height: 100%;
  overflow-y: auto;

  .main-content {
    font-family: 'Arial Normal', 'Arial';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    color: #333333;
    line-height: normal;

    .el-row {
      padding : 10px 0px;
    }
  }
}
</style>
